import React from 'react'
import styled from 'styled-components'

import { PairInformationCurrency } from '@root/entities/pair/ui'
import { PairIcon } from '@root/entities/pair/ui/common'
import { useFavorite } from '@root/features/favorite-pairs/hooks/use-favorite'
import { TrashIcon } from '@root/shared/ui-kit'

import type { PairModel } from '@root/entities/pair'

type FavoriteCurrencyCellProps = {
  value: PairModel
}

export const FavoriteCurrencyCell: React.FC<FavoriteCurrencyCellProps> =
  React.memo(({ value }) => {
    const { toggleFavorite } = useFavorite()

    const handleFavoriteAction = (e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation()
      toggleFavorite(value)
    }

    return (
      <Root>
        <FavoriteAction onClick={handleFavoriteAction}>
          <PairIcon pair={value} size={32} withPairPopover />
          <Overflow>
            <TrashIcon size={16} />
          </Overflow>
          <OverflowNetwork />
        </FavoriteAction>
        <PairInformationCurrency
          pair={value}
          withSocials={false}
          withAge={false}
        />
      </Root>
    )
  })

const Root = styled.div`
  display: grid;
  gap: 6px;
  grid-auto-flow: column;
  align-items: center;
  justify-content: start;
  padding-inline-end: 8px;
`

const Overflow = styled.div`
  background: var(--appearanceA-4);
  border-radius: 6px;
  transform: translateZ(0);

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  display: grid;
  place-items: center;

  overflow: hidden;

  opacity: 0;
`

const OverflowNetwork = styled(Overflow)`
  bottom: 0;
  right: 0;
  left: unset;
  top: unset;

  width: 10px;
  height: 10px;
`

const FavoriteAction = styled.div`
  cursor: pointer;
  position: relative;

  &:hover > ${Overflow}, &:hover > ${OverflowNetwork} {
    opacity: 1;
  }
`
